import { Key } from 'constants/keyboard';
import { WidgetType } from 'types/widget.types';

import { ArrowStyleTypes, LineWidgetDashArrayTypes } from '../common/CommonLine.types';
import { DeltaPos, LineWidgetTypes } from './LineWidget.types';

export const BOUNDING_BOX_CONFIG = {
  hideDefaultLines: true,
  resizable: false,
  rotatable: false,
  edgeDraggable: false,
};

export const DEFAULT_DELTA_POS: DeltaPos = {
  xPx: 0,
  yPx: 0,
};

// When drag line end, if angle of line 45degrees increment +/- tolerance, then it'll snap to the 45 degree increment.
export const ANGLE_SNAP_TOLERANCE: number = 3;

export const DEFAULT_MARGIN_STEPPED_LINE = 14;

// For the line renderer
export const DEFAULT_TYPE = LineWidgetTypes.straight;
export const DEFAULT_WIDTH = 140;
export const DEFAULT_HEIGHT = 140;
export const DEFAULT_FILL_COLOR = '#000';
export const DEFAULT_STROKE_WIDTH = 2;
export const DEFAULT_STROKE_DASH_TYPE = LineWidgetDashArrayTypes.solid;
export const DEFAULT_STROKE_START_ARROW_STYLE = ArrowStyleTypes.none;
export const DEFAULT_STROKE_END_ARROW_STYLE = ArrowStyleTypes.none;
export const DEFAULT_SHIFT_SNAP_ANGLE = 45;
export const DEFAULT_STROKE_SELECTION_TARGET = 10;

// For the custom handler
export const DEFAULT_CUSTOM_HANDLE_SIZE = 14;
export const DEFAULT_CUSTOM_HANDLE_BORDER_RADIUS = '50%';

// Minimum width or height that a line widget can have
export const MIN_WIDGET_SIZE = 20;

export const HANDLER_PADDING = 0;

export const KEYBOARD_CONFIG = {
  excludeSpecific: [Key.Enter],
};

// Widgets that allow center port connections
export const ENABLED_CENTER_WIDGET_TYPES = [WidgetType.BasicShape, WidgetType.Image, WidgetType.Group];
